import { StartingStepNodeGenericConverterRule } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converterRules/StartingStepNodeGenericConverterRule'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { createConverterRulesArray } from 'common/builder/components/chart/FlowChart/lib/utils/createConverterRulesArray'
import { FlowChartNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNode'
import { INode } from 'common/builder/nodes/nodeInterfaces'

import { ActionNodeGenericConverterRule } from './converterRules/ActionNodeGenericConverterRule'
import { AiStepNodeGenericConverterRule } from './converterRules/AiStepNodeGenericConverterRule'
import { CommentNodeGenericConverterRule } from './converterRules/CommentNodeGenericConverterRule'
import { ConditionNodeGenericConverterRule } from './converterRules/ConditionNodeGenericConverterRule'
import { FallbackNodeGenericConverterRule } from './converterRules/FallbackNodeGenericConverterRule'
import { GotoNodeGenericConverterRule } from './converterRules/GotoNodeGenericConverterRule'
import { SmartDelayGenericConverterRule } from './converterRules/SmartDelayGenericConverterRule'
import { SplitNodeGenericConverterRule } from './converterRules/SplitNodeGenericConverterRule'

export const GenericNodeConverterRules: Array<
  ConverterRule<INode, FlowChartNode, NodeConverterRulePayload>
> = createConverterRulesArray(
  [
    GotoNodeGenericConverterRule,
    StartingStepNodeGenericConverterRule,
    SmartDelayGenericConverterRule,
    SplitNodeGenericConverterRule,
    ConditionNodeGenericConverterRule,
    ActionNodeGenericConverterRule,
    CommentNodeGenericConverterRule,
    AiStepNodeGenericConverterRule,
  ],
  FallbackNodeGenericConverterRule,
)
